import validate from "/builds/contelizer-easyitem-com/prestashop-rest-front/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_67be9d6c4fec2b344def8eb49743e987/node_modules/nuxt/dist/pages/runtime/validate.js";
import catalog_45only_45global from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/middleware/catalog-only.global.ts";
import manifest_45route_45rule from "/builds/contelizer-easyitem-com/prestashop-rest-front/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_67be9d6c4fec2b344def8eb49743e987/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  catalog_45only_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/middleware/auth.ts"),
  "guest-only": () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/middleware/guest-only.ts")
}